module.exports = __webpack_public_path__ + "img/5e19f13.png";